export const GALLERY_IMAGE_EDITOR_CONSTS = {
  galleryView: 'Вид в галерее',
  cancel: 'Отмена',
  pastePhoto: 'Вставить фото',
  setAnotherPhotoLabelMsg: 'Установить другое фото',
  title: 'Вставка фото'
}
